export default class {
    constructor($scope, raceReplayService, browserDetectService, localStorageService) {
        'ngInject';
        Object.assign(this, {
            $scope,
            raceReplayService,
            browserDetectService,
            localStorageService,
            replayContainer: document.getElementById('replay-container'),
            videoControls: document.getElementsByClassName('rr-videoControls')[0],
            video: document.getElementById('replay-video'),
            seek: document.getElementById('seek'),
            volumeBar: document.getElementById('volume-bar'),
        });

        if ($scope.isCustomControls) {
            this.listenChanges();
            this.init();
        }
    }

    init = () => {
        Object.assign(this.$scope, {
            play: this.play,
            mute: this.mute,
            fullScreen: this.fullScreen,
            exitFullScreen: this.exitFullScreen,
            isPlaying: !this.video.paused,
            isMuted: this.video.muted,
            isVideoControlsHovered: false,
            hideTimer: null,
            controlsHovered: false,
        });
        this.initVolume();
    }

    initVolume = () => {
        const volume = this.localStorageService.getItem('replay-volume') || 0.5;
        this.video.volume = volume;
        this.volumeBar.value = volume;

        const isMuted = !!this.localStorageService.getItem('replay-muted');
        this.video.muted = isMuted;
        this.$scope.isMuted = isMuted;
    }

    listenChanges = () => {
        const rewindEvent = this.browserDetectService.getBrowser() === 'IE' ? 'change' : 'input';

        this.video.addEventListener('playing', this.onVideoPlay);
        this.video.addEventListener('pause', this.onVideoPause);
        this.video.addEventListener('timeupdate', this.onVideoTimeUpdate);

        this.volumeBar.addEventListener(rewindEvent, this.onVolumeChange);

        this.seek.addEventListener(rewindEvent, this.onRewindVideo);
        this.seek.addEventListener('mousedown', this.onRewindingStart);
        this.seek.addEventListener('mouseup', this.onRewindingEnd);

        this.replayContainer.addEventListener('mouseenter', this.onMouseEnterReplayContainer);
        this.replayContainer.addEventListener('mouseleave', this.onMouseLeaveReplayContainer);
        this.replayContainer.addEventListener('mousemove', this.onMouseMoveReplayContainer);

        this.videoControls.addEventListener('mouseenter', this.onMouseEnterVideoControls);
        this.videoControls.addEventListener('mouseleave', this.onMouseLeaveVideoControls);
    }

    onMouseEnterReplayContainer = () => {
        this.showControls();
        this.startTimerHideControls();
    }

    onMouseLeaveReplayContainer = () => {
        this.hideControls();
        this.stopTimerHideControls();
    }

    onMouseMoveReplayContainer = () => {
        this.showControls();
        this.startTimerHideControls();
    }

    startTimerHideControls() {
        this.stopTimerHideControls();
        this.$scope.hideTimer = setTimeout(this.hideControls.bind(this), 3000);
    }

    stopTimerHideControls() {
        clearTimeout(this.$scope.hideTimer);
        this.$scope.hideTimer = null;
    }

    showControls() {
        this.$scope.controlsHovered = true;
        this.$scope.$parent.containerHovered = true;
        this.$scope.$digest();
        this.$scope.$parent.$digest();
    }

    hideControls() {
        if (this.$scope.isPlaying && !this.$scope.isVideoControlsHovered) {
            this.$scope.controlsHovered = false;
            this.$scope.$parent.containerHovered = false;
            this.$scope.$digest();
            this.$scope.$parent.$digest();
        }
    }

    onMouseEnterVideoControls = () => {
        this.$scope.isVideoControlsHovered = true;
    }

    onMouseLeaveVideoControls = () => {
        this.$scope.isVideoControlsHovered = false;
    }

    onRewindingStart = () => {
        this.video.pause();
    }

    onRewindingEnd = () => {
        const duration = this.video.duration;
        const end = this.$scope.endSec && this.$scope.endSec < duration ?
            this.$scope.endSec :
            duration;
        if (this.video.currentTime >= end) return;

        this.video.play();
    }

    onVideoPlay = () => {
        this.$scope.isPlaying = true;
        this.$scope.$digest();
    }

    onVideoPause = () => {
        this.$scope.isPlaying = false;
        this.$scope.$digest();
    }

    onVideoTimeUpdate = () => {
        // console.log('-----------------------------------------');
        // console.log('ON VIDEO TIME UPDATE (setting seekValue)');
        // console.log('seekValue: ', this.seek.value);
        // console.log('currentTime: ', this.video.currentTime);
        // console.log('duration: ', this.video.duration);
        // console.log('startSec: ', this.$scope.startSec);
        // console.log('endSec: ', this.$scope.endSec);

        // this.seek.value = (100 / this.video.duration) * this.video.currentTime; // old
        // this.seek.value = (100 / (this.$scope.endSec - this.$scope.startSec)) *
        //     (this.video.currentTime - this.$scope.startSec); // new

        let seekValue = 0;

        let duration = this.video.duration;
        let currentTime = this.video.currentTime;

        const start = this.$scope.startSec ? this.$scope.startSec : 0;
        const end = this.$scope.endSec && this.$scope.endSec < duration ?
            this.$scope.endSec :
            duration;

        duration = end - start;
        currentTime = currentTime - start;

        if (duration > 0) seekValue = (100 / duration) * currentTime;
        if (seekValue < 0) seekValue = 0;
        if (seekValue > 100) seekValue = 100;

        this.seek.value = seekValue;
    }

    onVolumeChange = () => {
        this.video.volume = this.volumeBar.value;
        this.localStorageService.setItem('replay-volume', this.volumeBar.value);
    }

    onRewindVideo = () => {
        // console.log('-----------------------------------------');
        // console.log('ON REWIND VIDEO (setting currentTime)');
        // console.log('seekValue: ', this.seek.value);
        // console.log('currentTime: ', this.video.currentTime);
        // console.log('duration: ', this.video.duration);
        // console.log('startSec: ', this.$scope.startSec);
        // console.log('endSec: ', this.$scope.endSec);

        // this.video.currentTime = this.video.duration * (this.seek.value / 100); // old
        // this.video.currentTime = (this.$scope.endSec - this.$scope.startSec) *
        //     (this.seek.value / 100) + this.$scope.startSec; // new

        let currentTime = 0;
        let duration = this.video.duration;

        const start = +this.$scope.startSec ? +this.$scope.startSec : 0;
        const end = +this.$scope.endSec && +this.$scope.endSec < duration ?
            +this.$scope.endSec :
            duration;

        duration = end - start;

        if (duration < 0) duration = 0;

        currentTime = duration * (this.seek.value / 100) + start;

        if (currentTime < start) currentTime = start;
        if (currentTime > end) currentTime = end;

        this.video.currentTime = currentTime;
    }

    play = () => {
        if (this.video.paused === true) {
            const duration = this.video.duration;
            const end = this.$scope.endSec && this.$scope.endSec < duration ?
                this.$scope.endSec :
                duration;
            if (this.video.currentTime >= end) return;

            this.video.play();
        } else {
            this.video.pause();
        }
    }

    mute = () => {
        const isMuted = !this.video.muted;

        this.video.muted = isMuted;
        this.$scope.isMuted = isMuted;
        this.localStorageService.setItem('replay-muted', isMuted);
    }

    fullScreen = () => {
        this.raceReplayService.enterFullScreen(this.replayContainer);
    }

    exitFullScreen = () => {
        this.raceReplayService.exitFullScreen();
    }
}



// WEBPACK FOOTER //
// ./src/js/controllers/videoControlsCtrl.js